<template>
  <div>
    <router-view></router-view>
    <footer>
      <div class="container">
        <div class="row">
          <div class="col-md-4 my-auto">
            <span class="copyright">Copyright &copy; Wenger Hess & Partner 2018</span>
          </div>
          <div class="col-md-4"></div>
          <div class="col-md-4">
            <a href="http://www.wengerhess.ch/" aria-label="Hauptseite"><img src="./assets/logo.png" alt="Wenger Hess & Partner Logo"></a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false
    }
  }
}
</script>

<style lang="scss">
  @import "styles/whs";
</style>



// WEBPACK FOOTER //
// src/App.vue